<template>
    <div id="searchOnlineCarsMenuHamburger" :class="[orientation]">
        <div id="searchOnlineHamburgerIconButton" @click="openFlyoutMenu">
            <i class="fas fa-bars"></i>
        </div>
        <div id="searchOnlineCarsMenuFlyout" v-if="flyoutMenuOpen">
            <div id="playVideo" class="menuItem" @click="playVideo">
                Overview Video
            </div>
            <div id="showDeliveryCenter" class="menuItem" v-if="isLoggedIn" @click="displayCurrentDeliveryLocation">
                Closest Distribution Center
            </div>
            <div id="deliveryCenterForm" class="menuItem" v-if="isLoggedIn" @click="displayDeliveryLocationsForSelection">
                All Distribution Centers
            </div>
            <div id="virtualMeeting" class="menuItem" @click="openVirtualMeeting">
                Virtual Meeting
            </div>
            <div id="login" class="menuItem" v-if="!isLoggedIn" @click="openLoginForm">
                Admin Login
            </div>
            <div id="logout" class="menuItem" v-else @click="logout">
                Logout
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                flyoutMenuOpen: false
            }
        },
        mounted() {
            document.addEventListener('click', this.handleClickOutsideHamburgerMenu);
        },
        unmounted() {
            document.removeEventListener('click', this.handleClickOutsideHamburgerMenu)
        },
        computed: {
            isLoggedIn() {
                return this.$store.getters.isLoggedIn;
            },
            orientation() {
                return this.$store.getters.getOrientation;
            }
        },
        methods: {
            openFlyoutMenu() {
                this.flyoutMenuOpen = true;
            },
            closeFlyoutMenu() {
                this.flyoutMenuOpen = false;
            },
            handleClickOutsideHamburgerMenu(evt) {
                if (!this.$el.contains(evt.target)) {
                    this.closeFlyoutMenu();
                }
            },
			openLoginForm() {
				let eventLabel = this.$store.getters.isMobile ? 'mobile' : 'pc';
                this.$gtag.event('login', {'event_category': 'authentication','event_label': eventLabel});
                this.closeFlyoutMenu();
                //this.$router.push('/login');
                this.$store.commit('updateLoginFormVisible', true);
			},
			logout() {
				let eventLabel = this.$store.getters.isMobile ? 'mobile' : 'pc';
                this.$gtag.event('logout', {'event_category': 'authentication','event_label': eventLabel});
                this.closeFlyoutMenu();
                this.$store.dispatch('logout');
            },
            playVideo() {
                let eventLabel = this.$store.getters.isMobile ? 'mobile' : 'pc';
                this.$gtag.event('logout', {'event_category': 'video','play': eventLabel});
                this.closeFlyoutMenu();
                this.$store.commit('startYoutubeVideo');
            },
            displayCurrentDeliveryLocation() {
                let eventLabel = this.$store.getters.isMobile ? 'mobile' : 'pc';
                this.$gtag.event('open', {'event_category': 'delivery_location_display','event_label': eventLabel});
                this.closeFlyoutMenu();
                this.$store.commit('setCurrentDeliveryLocationDisplayOpenStatus', true);
            },
            displayDeliveryLocationsForSelection() {
                let eventLabel = this.$store.getters.isMobile ? 'mobile' : 'pc';
                this.$gtag.event('open', {'event_category': 'delivery_location_select','event_label': eventLabel});
                this.closeFlyoutMenu();
                this.$store.commit('setDeliveryLocationSelectOpenStatus', true);
            },
            openVirtualMeeting() {
                var appWindowFeatures = "location=yes,height=570,width=520,scrollbars=yes,status=yes";
                var appURL = this.$store.state.gubagooConversationsURL;
                
                let eventLabel = this.$store.getters.isMobile ? 'mobile' : 'pc';
                this.$gtag.event('open', {'event_category': 'virtual_meeting','event_label': eventLabel});
                
                this.closeFlyoutMenu();
                window.open(appURL, "_blank", appWindowFeatures);
            }
        }
    }
</script>

<style>
    #searchOnlineCarsMenuHamburger {
        position: absolute;
        top: calc(.5 * var(--vh));
        left: calc((10 * var(--vw)) + (.5 * var(--vh)));
        cursor: pointer;
    }

    .inmobile #searchOnlineCarsMenuHamburger {
        top: calc(2 * var(--vw));
        left: calc(2 * var(--vw));
    }

    .inmobile.tabletstyle #searchOnlineCarsMenuHamburger.landscape  {
        top: calc(.25 * var(--vw));
        left: calc(.25 * var(--vw));
    }

    #searchOnlineHamburgerIconButton {
        position: relative;
        color: var(--mccluskeyBlue);/*#0077C0;*//*#0079B6;*/
        height: calc(4 * var(--vw));
        width: calc(4 * var(--vw));
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 1.4em;
    }

    #searchOnlineCarsMenuFlyout {
        position: absolute;
        height: fit-content;
        background-color: #2B2A2B;
        border: 1px solid #707f99;
        top: calc(1.5 * var(--vw));
        left: calc(3 * var(--vw));
        width: fit-content;
        white-space: nowrap;
        padding: calc(.25 * var(--vw));
        border-radius: 2px;
        z-index: 20;
    }

    .menuItem {
        color: white;
        padding: calc(1.2 * var(--vh)) calc(1 * var(--vw));
        text-align: right;
        border-top: 1px solid #2B2A2B;
        border-bottom: 1px solid #545454;
        cursor: pointer;
    }

    .menuItem:hover {
        color: var(--mccluskeyGold); /*#AF873F;*/
        border-color: var(--mccluskeyGold); /* #AF873F;*/
        border-top: 1px solid;
    }
</style>